import { copApi } from 'api'
import { ApiResponse } from 'types/common/utils'
import { CommunityTag } from 'types/community-tags'

export const fetchCommunityTags = () => copApi.get<ApiResponse<CommunityTag>>('/community-tags')
